import React, { useState } from 'react'
import { BsFacebook, BsInstagram, BsWhatsapp } from 'react-icons/bs'
import logo2Dark from "../assets/logo2_no_bg_dark.png"
import logo2Light from "../assets/logo2_no_bg_light.png"
import { MdDeliveryDining } from "react-icons/md";
import { BiCheck } from 'react-icons/bi';
import { useLanguage } from '../translations/LanguageContext';

const Footer = () => {
  const socialLinks = [
    {
      name: 'WhatsApp',
      url: 'https://wa.me/+96103580388',
      Icon: BsWhatsapp,
      ariaLabel: 'WhatsApp'
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/profile.php?id=61574414203065&mibextid=ZbWKwL',
      Icon: BsFacebook,
      ariaLabel: 'Facebook'
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/restaurantabbas',
      Icon: BsInstagram,
      ariaLabel: 'Instagram'
    }
  ];

  const { t } = useLanguage();
  const openingTimes = t("openingTimes");

  const [showToast, setShowToast] = useState(false);

  const handleContactCopy = () => {
    const phoneNumber = '03580388';
    
    try {
      window.navigator.clipboard.writeText(phoneNumber);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gold-dark/20 dark:border-gold-dark/10 py-8 mt-4 shadow-inner">
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
        {/* Logo Section */}
        <div className="flex justify-center md:justify-start">
          <img 
            src={logo2Dark} 
            alt="logo2" 
            className="w-48 hidden dark:block hover:scale-105 transition-transform duration-300" 
          />
          <img 
            src={logo2Light} 
            alt="logo2" 
            className="w-48 block dark:hidden hover:scale-105 transition-transform duration-300" 
          />
        </div>

        {/* Opening Times Section */}
        <div className="text-center flex flex-col items-center gap-3 font-serif text-gold-dark ">
          <h2 className="text-2xl font-bold tracking-wider">
            {openingTimes.title}
          </h2>
          <div className='flex flex-col text-gray-700 dark:text-gray-300'>
            <p className="text-lg">{openingTimes.baseDays}</p>
            <p className="text-lg">{openingTimes.weekendDays}</p>
          </div>
          
          <div className='flex gap-2 items-center bg-gold-dark/10 dark:bg-gold-light/10 px-4 py-2 rounded-full' dir='ltr'>
            <MdDeliveryDining className='text-gold-dark text-3xl'/>
            <button 
              onClick={handleContactCopy} 
              className='group font-bold flex gap-1 text-gold-dark hover:text-opacity-70 transition-colors'
            >
              {['03', '58', '03', '88'].map((digit, index) => (
                <span key={index} className="hover:text-opacity-70">{digit}</span>
              ))}
            </button>
          </div>
        </div>

        {/* Social Links Section */}
        <div className="flex justify-center md:justify-end gap-6 text-gold-dark ">
          {socialLinks.map(({ name, url, Icon, ariaLabel }) => (
            <a
              key={name}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={ariaLabel}
              className="hover:scale-110 hover:text-opacity-70 transition-all duration-300 group"
            >
              <Icon className="text-4xl group-hover:rotate-6 group-hover:scale-110"/>
            </a>
          ))}
        </div>
      </div>

      {/* Toast Notification */}
      {showToast && (
        <div className="fixed bottom-20 left-1/2 -translate-x-1/2 bg-gray-800 dark:bg-slate-200 text-white dark:text-gray-900 px-4 
          py-3 rounded-lg flex items-center gap-2 text-sm shadow-lg z-50 text-nowrap">
          <BiCheck className="text-green-600 text-3xl" />
          {t("copied")}
        </div>
      )}
    </footer>
  )
}

export default Footer